<button
  [type]="type"
  class="btn btn-block btn-primary mb-4"
  [disabled]="isLoading"
>
  {{ btnLable }}
  <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
</button>
